// -- External libraries
import { mergeProps } from 'solid-js'
import { useLocale } from '../../../contexts/locale-context.jsx'
import { isExternalPath } from '../../../utils/path-utils.js'

export function useLinkAtomComponentController (props) {
    const defaultProps = {}
    const localeContext = useLocale()

    const merged = mergeProps(defaultProps, props)

    const localeHrefOverride = {
        get href () {
            const h = merged.href
            if (!merged.external
                && h
                && !isExternalPath(h)
                && localeContext?.addLocalePrefix) {
                return localeContext.addLocalePrefix(h)
            }
            return h
        },
    }

    return {
        mergedProps: mergeProps(merged, localeHrefOverride),
    }
}
